import React from 'react';

export default function LoadingSpinner({ fullPage = false, size = 'md', text = 'Loading...' }) {
  const spinner = (
    <div className={`d-flex flex-column align-items-center justify-content-center gap-2 ${fullPage ? 'loading-overlay' : 'p-4'}`}>
      <div className={`spinner-border text-primary spinner-border-${size}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {text && <span className="text-muted small">{text}</span>}
    </div>
  );
  return spinner;
}
